import BpkBadge, { BADGE_TYPES } from '@skyscanner-internal/backpack-web/bpk-component-badge';
import { BREAKPOINTS } from '@skyscanner-internal/backpack-web/bpk-component-breakpoint';
import BpkText, { TEXT_STYLES } from '@skyscanner-internal/backpack-web/bpk-component-text';
import { cssModules } from '@skyscanner-internal/backpack-web/bpk-react-utils';
import { useBreakpoint, useTranslations } from '@web-platform/shared-travel-tools-utils-frontend';
import { useOriginContext } from '@web-platform/travel-tools-flight-price-map-data-access-frontend';
import { getOriginCities } from '@web-platform/travel-tools-flight-price-map-utils-frontend';

import { OriginSelector } from './OriginSelector/OriginSelector';

import STYLES from './Hero.module.scss';

const cls = cssModules(STYLES);

export const Hero = () => {
  const { translate } = useTranslations();
  const originContext = useOriginContext();
  const isMobile = useBreakpoint(BREAKPOINTS.MOBILE);

  return (
    <section className={cls('hero')}>
      <div className={cls('inner')}>
        <BpkBadge type={BADGE_TYPES.strong} className={cls('betaBadge')}>
          {translate('travel_confidence_map_hero_beta_label')}
        </BpkBadge>
        <BpkText
          tagName="h1"
          textStyle={isMobile ? TEXT_STYLES.hero6 : TEXT_STYLES.hero4}
          className={cls('title')}
        >
          {translate('travel_confidence_map_hero_title')}
        </BpkText>
        <BpkText tagName="p" textStyle={TEXT_STYLES.bodyDefault} className={cls('subtitle')}>
          {translate('travel_confidence_map_hero_subtitle')}
        </BpkText>
        <div className={cls('filterChipWrapper')}>
          <OriginSelector cities={getOriginCities(originContext)} isMobile={isMobile} />
        </div>
      </div>
    </section>
  );
};
